<template>
    <div
        @click="onclick"
        data-component="native_open_web"
    >
        <slot></slot>
    </div>
</template>

<script type="text/ecmascript-6">
import { MPingClick, isJRAppKPL } from '@/util/common';

export default {
    name: 'NativeOpenWeb',
    props: {
        url: {
            type: String,
            default: ''
        },
        jumpType: {
            type: String,
            default: '8'
        },
        eventId: {
            type: String,
            default: '8'
        },
        eventParam: {
            type: String,
            default: '8'
        }
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {
        onclick() {
            const _url = this.url;
            const _jumpType = this.jumpType;
            try {
                MPingClick({ eventId: this.eventId, eventParam: this.eventParam });
            } catch (error) {
                console.log(error);
            }

            if (_url && $.device && $.device.jdjr && window.jsBridgeV3) {
                if (isJRAppKPL()) {
                    setTimeout(() => {
                        window.location.href = _url;
                    }, 200);
                    return false;
                }
                window.jsBridgeV3.onReady().then(api => {
                    api.jsOpenWeb({
                        //跳转到金融APP原生模块
                        jumpUrl: _url, //参考上边64-67的区别
                        jumpType: _jumpType, //登陆类型
                        productId: '', //参考上边64-67的区别
                        isclose: false //是否关闭m页，true关，false不关
                    });
                });
            } else if (_url) {
                setTimeout(() => {
                    window.location.href = _url;
                }, 200);
            }
        }
    },
    destroyed() {
        this.$refs = null;
        this._self = null;
    }
};
</script>
